import type { RequestResult } from '@trellis/shared'

import { env } from '@/env'

/* TODO: Derive from generated backend API types once tenant membership endpoint has Swagger decorators with response DTOs */
export interface TenantMembershipResponse {
  tenantId: string
  slug: string
  displayName: string
  role: string
  status: string
}

export async function listMyTenants(): Promise<
  RequestResult<TenantMembershipResponse[]>
> {
  try {
    const response = await fetch(`${env.VITE_API_BASE_URL}/api/users/me/tenants`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })

    const body = await response.json()

    if (!response.ok) {
      return {
        status: response.status,
        data: null,
        pagination: null,
        error: {
          code: body.code ?? 'API_ERROR',
          message: body.message ?? 'Failed to fetch tenant memberships',
        },
      }
    }

    return {
      status: response.status,
      data: body.data as TenantMembershipResponse[],
      pagination: null,
      error: null,
    }
  } catch (caughtError) {
    return {
      status: 500,
      data: null,
      pagination: null,
      error: {
        code: 'NETWORK_ERROR',
        message: caughtError instanceof Error ? caughtError.message : 'Request failed',
      },
    }
  }
}
